import { Client } from 'urql';

import {
  GetSignedUploadImageUrlDocument,
  GetSignedUploadImageUrlQuery,
} from '@/graphql/types/generated';

/**
 * Puts a file in S3 and returns the key the API stores.
 *
 * Callers upload sequentially: urql deduplicates identical in-flight queries,
 * so two files asking for a signed URL at once share one and overwrite each
 * other.
 */
export async function uploadImage(client: Client, file: File): Promise<string> {
  const extension = file.name.split('.').pop() || '';
  const result = await client
    .query<GetSignedUploadImageUrlQuery>(
      GetSignedUploadImageUrlDocument,
      { extension },
      { requestPolicy: 'network-only' },
    )
    .toPromise();

  const signedUrl = result.data?.signedUploadImageUrl?.url;
  const key = result.data?.signedUploadImageUrl?.key;
  if (!signedUrl || !key) {
    throw new Error('Failed to get upload URL');
  }

  const response = await fetch(signedUrl, { method: 'PUT', body: file });
  if (!response.ok) {
    throw new Error('Upload failed');
  }
  return key;
}
